var exports = {
  "x": "xa15a2ab7--1efe7d--button",
  "K": "xa15a2ab7--1efe7d--icon",
};

module.exports = exports;
